export const Portfolio = () => {
    return (
        <section
            id="portfolio"
            data-testid="portfolio-section"
            className="px-6 lg:px-12 py-24 lg:py-32 border-t border-black/15 bg-paper"
        >
            <div className="max-w-[1440px] mx-auto">
                <div className="mb-14 lg:mb-20">
                    <p className="overline text-center" data-testid="portfolio-overline">
                        (02) — Records
                    </p>
                    <h2
                        data-testid="portfolio-title"
                        className="mt-4 font-serif-display text-5xl sm:text-6xl lg:text-7xl tracking-[-0.02em] leading-[0.95] text-ink text-center"
                    >
                        SONICS
                    </h2>
                </div>

                <div data-testid="portfolio-spotify-wrap">
                    <div className="border border-black/15 p-2 bg-bone">
                        <iframe
                            title="Denis Catapano — selected works"
                            data-testid="portfolio-spotify-iframe"
                            src="https://open.spotify.com/embed/playlist/0diTukmwsGp7dFhQVPpfCC?utm_source=generator&theme=0"
                            width="100%"
                            height="520"
                            frameBorder="0"
                            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                            loading="lazy"
                            className="block w-full"
                        />
                    </div>
                    <p className="mt-4 font-mono text-[11px] tracking-[0.18em] uppercase text-quiet">
                        Press play — listen on Spotify
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Portfolio;
